import {
  PropertySubType
} from "./chunk-VXLCCQ5A.js";

// src/constants/apiUrls.ts
var BFF_ENV_URL_MAP = {
  dev: "https://search-bff.envdevel.com/",
  stage: "https://search-bff.envstage.com/",
  prod: "https://search-bff.engelvoelkers.com/"
};
var SEARCH_API_ENV_URL_MAP = {
  dev: "https://search-api.envdevel.com/",
  stage: "https://search-api.envstage.com/",
  prod: "https://search-api.engelvoelkers.com/"
};
var AI_CHAT_BOT_ENV_URL_MAP = {
  dev: "https://ai-chat-bot.envdevel.com/",
  stage: "https://ai-chat-bot.envstage.com/",
  prod: "https://ai-chat-bot.engelvoelkers.com/"
};

// src/constants/filters.ts
var APARTMENT_SUB_TYPES = [
  PropertySubType.attic,
  PropertySubType.flat,
  PropertySubType.loft,
  PropertySubType.maisonette,
  PropertySubType.penthouse,
  PropertySubType.other
];
var HOUSE_SUB_TYPES = [
  PropertySubType.apartment_house,
  PropertySubType.bungalow,
  PropertySubType.country_house,
  PropertySubType.castle,
  PropertySubType.detached_house,
  PropertySubType.investment,
  PropertySubType.semi_detached_house,
  PropertySubType.terraced_house,
  PropertySubType.townhouse,
  PropertySubType.villa,
  PropertySubType.special_property,
  PropertySubType.other
];
var LAND_SUB_TYPES = [
  PropertySubType.land,
  PropertySubType.site,
  PropertySubType.parking,
  PropertySubType.other
];

// src/constants/propertyData.ts
var DISPLAY_ID_PREFIXES = [
  "AER-S",
  "AER-R",
  "AM-",
  "D-0",
  "DNK-",
  String.raw`ENV\d`,
  "EVHK",
  "EVO-",
  "GES-",
  "PRA-",
  "T-",
  "W-0",
  "BCN-",
  "AEC-",
  "LIS-",
  "MAD-",
  "VLC-",
  "MIL-",
  "OI-",
  String.raw`CL\d`,
  // the prefix starts with CL and the next char is a number
  String.raw`RL\d`,
  "G-0",
  "EAVCHCOM",
  "EVADEV-",
  // CZ prefixes
  "EVP-",
  "EVL-",
  "EVB-"
];

export {
  BFF_ENV_URL_MAP,
  SEARCH_API_ENV_URL_MAP,
  AI_CHAT_BOT_ENV_URL_MAP,
  APARTMENT_SUB_TYPES,
  HOUSE_SUB_TYPES,
  LAND_SUB_TYPES,
  DISPLAY_ID_PREFIXES
};
